import getAlgoliaIndex from '../services/algolia/getAlgoliaIndex';

export function searchTags(query) {
  return new Promise((resolve, reject) => getAlgoliaIndex('tags').search(query, { hitsPerPage: 5 })
    .then((res) => resolve(res))
    .catch((err) => reject(err)));
}
